export function modules($, slick) {

  const $words = $('[data-word]');
  const timeWords = 2000;

  if ($words.length) {
    $words.each(function(i, e) {
      let wordsArr = $(e).attr('data-word').split(',');

      let num = 0,
          numLength = wordsArr.length;

      setTimeout(function() {
        $(e).addClass('mod');
      }, timeWords - 200);

      window.setInterval(function () {

        $(e).removeClass('mod').text(wordsArr[num]);
        num = (num + 1) % numLength;
        setTimeout(function() {
          $(e).addClass('mod');
        }, timeWords - 200);

      }, timeWords);

    });
  }

  // HERO FADE BACKGROUND
  const $hero = $('.js--herobackground');
  const timeHero = 4000;

  if ($hero.length) {
    $hero.children().first().addClass('current');

    window.setInterval(function () {

      let $current = $hero.children('.current');

      if ($current.next().length) {
        $current.removeClass('current').next().addClass('current');
      } else {
        $current.removeClass('current');
        $hero.children().first().addClass('current')
      }

    }, timeHero);
  }


  $('.js--showmore').click(function(e) {
    let $target = $(this).closest('.module').find('.js--showmore-target');
    $(this).toggleClass('active');
    $target.toggleClass('show');
  });


  const $sliderExperts = $('.slider--experts');
  const $sliderOpinion = $('.slider--opinions');
  const $sliderCourses = $('.slider--courses');
  const $sliderLogos = $('.slider--logos');

  if ($sliderExperts.length) {
    $sliderExperts.slick({
      arrows: false,
      dots : true,
      slidesToShow: 3,
      slidesToScroll: 3,
      variableWidth: false,
      infinite : true,
      responsive : [
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
  }
  if ($sliderLogos.length) {
    $sliderLogos.slick({
      arrows: false,
      dots : true,
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite : true,
      responsive : [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
  }

  if ($sliderOpinion.length) {
    $sliderOpinion.slick({
      arrows: false,
      dots : true
    });
  }

  if ($sliderCourses.length) {
    $sliderCourses.slick({
      arrows: false,
      dots : true,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: true,
      infinite : false,
      responsive : [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    });
  }

}
